export default __webpack_public_path__ + "static/media/Metallic-Beauty-Boho-Style-Memory-Wire-Bracelet.c7795144.jpg";